import { WarehouseID } from "./Address";
import { Brand } from "./Brand";
import { Channel } from "./Channel";
import { Group } from "./Group";
import { Image } from "./Image";
import { OrderType } from "./Order";
import { SubBrand } from "./SubBrand";
import { Territory } from "./Territory";
import { VariablePricing } from "./VariablePricing";
import { Variant } from "./Variant";

type DateString = string;

export const isAllowedTierPricingByOrderType = (orderType: OrderType) => {
  return ["on-demand", "pre-order"].includes(orderType);
};

/**
 * Known custom fields. Plugins augment this interface for fields they own.
 */
// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface ItemCustomFields {}

export type Item = {
  id: string;
  status: "draft" | "complete";
  cost: number;
  defaultExternalWarehouseId: string | null;
  description: string;
  previewText: string;
  isActive: boolean;
  leadTimeInDays: number;
  minimumOrderQuantity: number;
  name: string;
  orderType: OrderType;
  orderableStartDate: DateString | null;
  orderableEndDate: DateString | null;
  packSize: number;
  price: number;
  channelPricing: Record<number, string>;
  sku: string;
  specificationTuples: [string, string][] | null;
  unitOfMeasure: "ea" | "pack";
  visibleStartDate: DateString | null;
  visibleEndDate: DateString | null;
  warehouse: WarehouseID | null;
  weight: number;
  isCustomizable: boolean;
  customizationDescription: string;
  isBundle: boolean;
  onHand: number;

  countryOfOriginId: number | null;
  htsCode: string | null;
  images: Image[];
  variants: Variant[];
  variablePricing: VariablePricing[];
  // Many to Many
  brands: Brand[];
  subBrands: SubBrand[];
  groups: Group[];
  territories: Territory[];
  channels: Channel[];
  promotions: any[];
  customFields: ItemCustomFields;
};

const itemTransformer = {
  // We can optionally define the plural like this
  type: ["item", "items"],
  deserialize: (attr) => ({
    ...attr,
    cost: Number(attr.cost),
    price: Number(attr.price),
  }),
  serialize: (item) => ({
    ...item,
    cost: item.cost?.toString(),
    price: item.price?.toString(),
  }),
};

export default itemTransformer;
